var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramPerson40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,8 C6.20914,8 8,6.20914 8,4 C8,1.79086 6.20914,0 4,0 C1.79086,0 0,1.79086 0,4 C0,6.20914 1.79086,8 4,8 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5 C0,3.3578625 2.68629,0 6,0 C9.31371,0 12,3.3578625 12,7.5 L12,15 L0,15 L0,7.5 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 12 0 12 5 0 5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.5 -2.5 10.5 -2.5 10.5 10.5 -2.5 10.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C8.20914,8 10,6.20914 10,4 C10,1.790861 8.20914,0 6,0 C3.790861,0 2,1.790861 2,4 C2,6.20914 3.790861,8 6,8 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.5 -2.67857143 14.5 -2.67857143 14.5 17.6785714 -2.5 17.6785714"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.5 C0,11.3578646 2.6862915,8 6,8 C9.31371,8 12,11.3578646 12,15.5 L12,23 L0,23 L0,15.5 Z",
    id: "Stroke-8",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFCC00",
    mask: "url(#mask-6)",
    points: "-2.5 -3.125 14.5 -3.125 14.5 8.12500063 -2.5 8.12500063"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-12",
    stroke: "#4F4C4D",
    points: "0 18 12 18 12 23 0 23"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPerson40);
export default __webpack_public_path__ + "static/media/pictogramPerson40.f9b560ce1617629d13373ecd5088bb9d.svg";
export { ForwardRef as ReactComponent };